import { SVGProps } from 'react';

export default function AvataraLogo(props: SVGProps<SVGSVGElement>) {
  return <img src="/favicon-32x32.png" className={props.className} alt="Avatara" />;
}
